import { useEffect } from "react";
import { Routes } from "react-router-dom";
import "@grapecity/spread-sheets/styles/gc.spread.sheets.excel2013white.css";
import "@grapecity/spread-sheets-charts";

import AuthRoutes from "./core/routes/AuthRoutes";
import UnAuthRoutes from "./core/routes/UnAuthRoutes";

import { SpreadWrapperProvider } from "./shared/screen-components/ExcelViewComponent/SpreadWrapperContext";
import { AgGridProvider } from "./shared/screen-components/AgGridComponent/AgGridContext";
import { ThemeProvider } from "./theme";
import { PartnershipProvider } from "./core/context/PartnershipContext";

function App() {
  useEffect(() => {
    // Redirect handling moved to index.tsx (pre-render).
    // App.tsx no longer needs to call handleRedirectPromise().
  }, []);

  return (
    <div className="App">
      <ThemeProvider>
        <PartnershipProvider>
          <AgGridProvider>
            <SpreadWrapperProvider>
              <Routes>
                {UnAuthRoutes}
                {AuthRoutes}
              </Routes>
            </SpreadWrapperProvider>
          </AgGridProvider>
        </PartnershipProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
